import React from "react";
import { Controller } from "react-hook-form";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormHelperText, OutlinedInput, Typography } from "@mui/material";
import { StyledMenuItem } from "../StyledComponent";

const YearMonthPicker = ({
  yearPlaceholder = "Year",
  monthPlaceholder = "Month",
  name, // Existing field where concatenated value will be stored
  control,
  validation,
  defaultValue,
  disabled,
  width = "9vw", // Half width for side-by-side
  height = "30px",
}) => {
  const years = Array.from({ length: 30 }, (_, i) => i); // Year options (0-29)
  const months = Array.from({ length: 12 }, (_, i) => i); // Month options (0-11)

  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      defaultValue={defaultValue || ""}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        // Parse current value into year and month
        const [currentYear, currentMonth] = value ? value.split("-").map((item) => parseInt(item.match(/\d+/), 10)) : [null, null];

        const handleChange = (type, selectedValue) => {
          const updatedYear = type === "year" ? selectedValue : currentYear || 0;
          const updatedMonth = type === "month" ? selectedValue : currentMonth || 0;

          const yearLabel = updatedYear === 1 || updatedYear === 0 ? "Year" : "Years";
          const monthLabel = updatedMonth === 1 ? "Month" : "Months";
          // Update field with concatenated string
          const formattedValue = `${updatedYear || 0} ${yearLabel}-${updatedMonth || 0} ${monthLabel}`;
          onChange(formattedValue);
        };

        return (
          <div style={{ display: "flex", gap: "10px" }}>
            {/* Year Dropdown */}
            <FormControl sx={{ width, borderRadius: "5px" }} size="small" error={!!error} disabled={disabled}>
              <Select
                value={currentYear || ""}
                onChange={(e) => handleChange("year", e.target.value)}
                displayEmpty
                input={<OutlinedInput style={{ borderRadius: "5px", height }} />}
                renderValue={(selected) => {
                  if (!selected) {
                    return <em style={{ fontStyle: "normal" }}>{yearPlaceholder}</em>;
                  }
                  return selected > 1 ? `${selected} Years` : selected === 0 || selected === 1 ? `${selected} Year` : "";
                }}
                inputProps={{ "aria-label": "Year Dropdown" }}
              >
                <StyledMenuItem disabled value="">
                  <em style={{ fontStyle: "normal" }}>{yearPlaceholder}</em>
                </StyledMenuItem>
                {years.map((item) => (
                  <StyledMenuItem key={item} value={item}>
                    {item}
                  </StyledMenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Month Dropdown */}
            <FormControl sx={{ width, borderRadius: "5px" }} size="small" error={!!error} disabled={disabled}>
              <Select
                value={currentMonth || ""}
                onChange={(e) => handleChange("month", e.target.value)}
                displayEmpty
                input={<OutlinedInput style={{ borderRadius: "5px", height }} />}
                renderValue={(selected) => {
                  if (!selected && selected !== 0) {
                    return <em style={{ fontStyle: "normal" }}>{monthPlaceholder}</em>;
                  }
                  return selected === 1 ? `${selected} Month` : `${selected} Months`;
                }}
                inputProps={{ "aria-label": "Month Dropdown" }}
              >
                <StyledMenuItem disabled value="">
                  <em style={{ fontStyle: "normal" }}>{monthPlaceholder}</em>
                </StyledMenuItem>
                {months.map((item) => (
                  <StyledMenuItem key={item} value={item}>
                    {item}
                  </StyledMenuItem>
                ))}
              </Select>
            </FormControl>
            {error && (
              <Typography variant="caption" className="error-message">
                {error.message}
              </Typography>
            )}
          </div>
        );
      }}
    />
  );
};

export default YearMonthPicker;
